export class CopyToClipBoard {

    static copyToClipBoard = (id, props) => {
        props.publishSuccessAlert("Copiado com sucesso!");
        console.log(document.getElementById(id));
        let valToCopy = document.getElementById(id).innerText;
        let textarea = document.createElement('textarea');

        textarea.innerText = valToCopy;
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        textarea.remove();
    }
}
